import { useMutation, useQueryClient } from "@tanstack/react-query";

import { resetOverride } from "./api";
import type { Role } from "./api";

// Откат промпта роли к default'у (DELETE
// /agent_roles/{role}/prompt). Идемпотентно на backend. На успех
// инвалидируем весь префикс `agent-roles` — список (badge override
// исчезает), detail (has_prompt_override=false, effective_system_prompt
// = default) и общая история override'ов (новая запись action: delete)
// перечитаются. Ошибку (404 нет роли) пробрасываем для тоста.
export function useResetOverride(): ReturnType<
  typeof useMutation<Role, Error, string>
> {
  const queryClient = useQueryClient();
  return useMutation<Role, Error, string>({
    mutationFn: (roleName) => resetOverride(roleName),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["agent-roles"] });
    },
  });
}
